import { render, staticRenderFns } from "./AbrRoot.vue?vue&type=template&id=687a90b6"
import script from "./AbrRoot.vue?vue&type=script&lang=js"
export * from "./AbrRoot.vue?vue&type=script&lang=js"
import style0 from "./AbrRoot.vue?vue&type=style&index=0&id=687a90b6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports